<template>
    <div>
        <v-container grid-list-xs fluid>
            <dynamic-toolbar title="Documents & Categories" :loading="loading.lists" color="indigo"
                icon="mdi-note-search" theme="dark">
                <template #buttons>
                    <v-btn color="blue" depressed @click="openAddDialog" large dark>
                        <v-icon left>mdi-plus-circle</v-icon>
                        New
                    </v-btn>
                </template>
            </dynamic-toolbar>
            <v-container grid-list-xs>
                <v-data-table :headers="place == 0 ? headersMain : place == 1 ? headersSub : headersDocs"
                    :items="place == 0 ? all : place == 1 ? subcategories : documents">
                    <template v-slot:top>
                        <v-toolbar dense dark color="secondary">
                            <v-spacer />
                            <v-toolbar-title class="white--text">{{ place == 0 ? 'Main Categories' : place == 1 ?
                                'Sub-Categories' : 'Documents' }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn v-if="place > 0" icon @click="lessBack"><v-icon>mdi-arrow-left</v-icon></v-btn>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.viewSubs="{ item }">
                        <v-icon class="mx-3" color="secondary"
                            @click="showSub(item.subcategory, item.MainCatId)">mdi-location-enter</v-icon>
                    </template>

                    <template v-slot:item.viewDocs="{ item }">
                        <v-icon class="mx-3" color="secondary"
                            @click="showDocs(item.docs, item.SubCatId)">mdi-location-enter</v-icon>
                    </template>

                    
                    <template v-slot:item.Rename="{ item, idx }">
                        <v-icon class="mx-3" color="secondary"
                            @click="rename(item ,idx)">mdi-rename-box</v-icon>
                    </template>
                    <template v-slot:item.Delete="{ item, idx }">
                        <v-icon class="mx-3" color="red"
                            @click="dltDocument(item ,idx)">mdi-delete</v-icon>
                    </template>
                    <!-- <template v-slot:item.Add="{ item }">
                        <v-icon
                            class="mx-3"
                            color="secondary"
                            @click="showSub(item.subcategory)"
                            >mdi-plus-circle</v-icon
                        >
                    </template> -->
                </v-data-table>
                
            <confirm-dialogue ref="confirmDialogue" style="z-index: 100;"></confirm-dialogue>
            </v-container>
        </v-container>
        <new_dc v-if="showAdd" :place="place" :url="url" :showAdd="showAdd" :fld="fld" :parms="parms"
            @close="showAdd = false;" @closePush="pushData()" @push="rtdata = $event" ></new_dc>


            <edt_dc v-if="showEdt" @close="showEdt = false;" :place="place" :name="name" @closeUpdate="loadCategories()"
            :url="edtUrl" :id="id" :showEdt="showEdt" :fld="fld" :parms="parms"></edt_dc>

    </div>
</template>
<script>

import axios from "axios";
import ConfirmDialogue from '@/components/Modals/ConfirmDialogue.vue';
import DateRangeMenu from '@/components/Global/Utils/DateRangeMenu.vue';
import DynamicToolbar from '@/components/Global/Utils/DynamicToolbar.vue';
import new_dc from '@/components/Modals/Catalogs/Docs/AddDocOrCat.vue';
import edt_dc from '@/components/Modals/Catalogs/Docs/EditName.vue';

export default {
    components: {
        DynamicToolbar,
        DateRangeMenu,
        new_dc,
        ConfirmDialogue,
        edt_dc
    },
    data: function () {
        return {
            loading: {
                lists: false,
                cost: false,
                dateRangeTotalCost: false,
                totalCostByType: false,
                totalCostByEquipment: false,
                totalCostByCategory: false,
                totalCostBySubcategory: false,
                report: false
            },
            edtUrl:false,
            idx:null,
            id:0,
            name:'',
            showEdt: false,
            url: 'main-category',
            parms: {},
            rtdata: {},
            all: [],
            showAdd: false,
            subcategories: [],
            documents: [],
            place: 0,
            fld: 'MainCategory',
            headersMain: [
                { text: 'id', value: 'MainCatId' },
                { text: 'Main Category', value: 'MainCategory' },
                { text: 'View SubCategories', value: 'viewSubs' },
                { text: 'Rename', value: 'Rename' },
            ],

            headersSub: [
                { text: 'id', value: 'SubCatId' },
                { text: 'SubCategory', value: 'SubCategory' },
                { text: 'View SubCategories', value: 'viewDocs' },
                { text: 'Rename', value: 'Rename' },
            ],


            headersDocs: [
                { text: 'id', value: 'documentId' },
                { text: 'Document', value: 'Document' },
                { text: 'Ok', value: 'Ok' },
                { text: 'Pending', value: 'Pending' },
                { text: 'NoApplay', value: 'NoApplay' },
                { text: 'Rename', value: 'Rename' },
                { text: 'Delete', value: 'Delete' },
            ],
        }
    },
    methods: {
        async dltDocument(itm, idx) {
            if (this.place == 2) {
                const ok = await this.$refs.confirmDialogue.show({
                    title: 'You are about to delete a document',
                    message: 'Are you sure?',
                    okButton: 'Yes',
                    cancelButton: 'No'
                });
                // If you throw an error, the method will terminate here unless you surround it wil try/catch
                if (ok) {
                   this.dtlDocument(itm, idx);
                }
            } 
        },
        dtlDocument: function (itm, idx) {
            var str = this.$store;
            axios
                .delete('document/' + itm.documentId, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Delete Invoice successful.'
                    });
                    this.documents.splice(idx, 1);

                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        loadCategories: function () {
            this.$store.state.isLoading = true;
            var str = this.$store;
            axios
                .get('main-category/all', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.all = response.data;
                    this.$store.state.isLoading = false;
                    this.dataLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                });
        },
        rename: function (itm) {
            console.log(itm);
            switch (this.place) {
                case 0:
                    this.edtUrl = 'main-category/';
                    this.id  = itm.MainCatId;
                    this.parms.MainCategory = null;
                    this.name = itm.MainCategory;
                    this.fld = 'MainCategory';
                    
                    this.showEdt = true;
                    break;
                case 1:
                    this.edtUrl = 'sub-category/';
                    this.id = itm.SubCatId;
                     this.parms.SubCategory = null;
                    this.name = itm.SubCategory;
                    this.fld = 'SubCategory';
                    
                    this.showEdt = true;
                    break;
                case 2:
                    this.edtUrl = 'document/';
                    this.id = itm.documentId;
                    this.name = itm.Document;
                     this.parms.Document = null;
                    this.fld = 'Document';
                    
                    this.showEdt = true;
                    break;
            }
            console.log(this.url,this.id);
        },
        pushData: function () {
            switch (this.place) {
                case 0:
                    this.all.push(this.rtdata);
                    break;

                case 1:
                    this.subcategories.push(this.rtdata);
                    break;

                case 2:
                    this.documents.push(this.rtdata);
                    break;
            }
        },
        openAddDialog: function () {
            this.showAdd = true;
            if (this.place == 0) {
                this.parms = {};
                this.parms.MainCategory = null;
                this.fld = 'MainCategory';
                this.url = 'main-category';
            }
        },
        lessBack: function () {
            this.place = this.place - 1;
            if (this.place == 0) {
                this.parms = {};
                this.parms.MainCategory = null;
                this.fld = 'MainCategory';
                this.url = 'main-category';
            }

        },
        showSub: function (itm, id) {
            this.parms = {};
            this.url = 'sub-category';
            this.parms.main_cat = id;
            this.parms.SubCategory = null;
            this.fld = 'SubCategory';
            this.subcategories = itm;
            this.place = 1;
        },
        showDocs: function (itm, id) {
            this.parms = {};
            this.url = 'document';
            this.documents = itm;
            this.parms.DocCategory = id;
            this.fld = 'Document';
            this.place = 2;
        },
    },
    mounted() {
        this.loadCategories();
    }
}
</script>